<template lang="html">
  <transition name="modal-fade">
    <div class="modal-background">

      <div id="group-edit-popup" class="container white-box text-center col-lg-4 col-md-4 col-sm-6 col-11" role="dialog">

        <header id="edit-group-headline">
          <span id="group-edit-close-btn" role="button" aria-label="Gå tilbage" @click="$emit('close')" tabindex="0">
            <span class="material-icons grey-text" aria-hidden="true">close</span>
          </span>
          <h4>{{ groupName }}</h4>
        </header>

        <section>
        	<button class="blue btn col-12" @click="$emit('editContent');" tabindex="0">Tilføj/fjern indhold</button>
        	<button class="blue btn col-12" @click="$emit('rename');" tabindex="0">Omdøb samlingen</button>
        	<button class="dark-grey btn col-12" @click="$emit('delete')" tabindex="0">Slet samlingen</button>
        </section>

      </div>

    </div>
  </transition>

</template>

<script>
export default {
  props: {
    groupName: {

    }
  },
  mounted() {
    this.$HelperFunctions.setScreenReaderFocus('edit-group-headline');
  }
}
</script>

<style lang="css" scoped>
  #group-edit-popup {
    padding: 10px;
  }

  #group-edit-popup .btn {
  	display: block;
  	margin-top: 20px;
  	width: 150px;
  	margin-left: auto;
  	margin-right: auto;
  }

  #group-edit-popup .btn:last-child {
  	margin-bottom: 10px;
  }

  #group-edit-close-btn {
  	position: absolute;
    height: 30px;
    top: 4px;
    right: 5px;
    cursor: pointer;
  }
</style>
